import {
  Divider,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import ArrowLeftIcon from '../../../../Icons/ArrowLeftIcon';
import { Dispatch, SetStateAction } from 'react';
import { SnackbarSeverityEnum } from '../../../../../enums/snackbar-severity-enum';
import { PhotoAlbum } from '../../../../../interfaces/media.interface';
import SectionLayout from '../../../../../layouts/SectionLayout';
import PhotoArea from '../photos-tab/PhotoArea';
import { useCurrentPageUserId } from '../../../../../hooks/useCurrentPageUserId';

interface SinglePhotoAlbumProps {
  album: PhotoAlbum;
  addButton: React.ReactNode;
  handleBackToAlbums: () => void;
  setSnackbarOpen: Dispatch<SetStateAction<boolean>>;
  setSnackbarMessage: Dispatch<SetStateAction<string>>;
  setSnackbarSeverity: Dispatch<SetStateAction<SnackbarSeverityEnum>>;
}

const SinglePhotoAlbum = ({
  album,
  addButton,
  handleBackToAlbums,
  setSnackbarOpen,
  setSnackbarMessage,
  setSnackbarSeverity,
}: SinglePhotoAlbumProps) => {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('md'));
  const { isOwnPage } = useCurrentPageUserId();

  return (
    <SectionLayout
      display="flex"
      flexDirection="column"
      gap={mobileView ? '28px' : '36px'}
    >
      <Typography
        variant="body1"
        display="flex"
        alignItems="center"
        onClick={handleBackToAlbums}
        sx={{ cursor: 'pointer' }}
        width="fit-content"
      >
        <ArrowLeftIcon />
        &nbsp;&nbsp;All albums
      </Typography>
      <Divider sx={{ mt: '-10px' }} />

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h2">{album.name}</Typography>
        {isOwnPage && addButton}
      </Stack>

      <PhotoArea
        album={album}
        setSnackbarOpen={setSnackbarOpen}
        setSnackbarMessage={setSnackbarMessage}
        setSnackbarSeverity={setSnackbarSeverity}
      />
    </SectionLayout>
  );
};

export default SinglePhotoAlbum;
